import { createRequire } from 'module';

const require = createRequire(import.meta.url);

export const { version } = require('../package.json');
